import { Fetch } from '.';
import { DocInfo } from '../types/DocInfo';

export const getDocInfo =
  (f: Fetch) =>
  async (q: string): Promise<DocInfo> => {
    const r = await f.graphQLFetch<DocInfo>(
      process.env.CPP_CONTENT_URI + '/item',
      q
    );
    if (!r) throw new Error('Failed to get document info');
    return r;
  };
